import LandingPageLoggedinContent from "./LandingPageLoggedinContent";
import LandingPagePublicContent from "./LandingPageLoggedoutContent";
import { useAuth } from "react-oidc-context";

export default function LandingPage(): JSX.Element {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? <LandingPageLoggedinContent /> : <LandingPagePublicContent />;
}
